// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2BHb0","title":"FrontImage_title__2KMHq"};